import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentQuoteSkeleton } from './TypeComponentQuote'
import type { TypeResourceCalloutSkeleton } from './TypeResourceCallout'
import type { TypeResourceImageSkeleton } from './TypeResourceImage'

export interface TypeResourceContentFields {
  title?: EntryFieldTypes.Symbol
  body?: EntryFieldTypes.RichText
  callouts?: EntryFieldTypes.Array<
    EntryFieldTypes.EntryLink<TypeComponentQuoteSkeleton | TypeResourceCalloutSkeleton | TypeResourceImageSkeleton>
  >
}

export type TypeResourceContentSkeleton = EntrySkeletonType<TypeResourceContentFields, 'resourceContent'>
export type TypeResourceContent<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeResourceContentSkeleton,
  Modifiers,
  Locales
>

export function isTypeResourceContent<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeResourceContent<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'resourceContent'
}
